import { render, staticRenderFns } from "./DownloadHandler.vue?vue&type=template&id=e4333082"
import script from "./DownloadHandler.vue?vue&type=script&lang=js"
export * from "./DownloadHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports